module.exports = __webpack_public_path__ + "static/media/goodvision.e344a86a.jpg";